import { useBrandPageBrandViewContext } from "@faire/retailer-visitor-shared/views/brand/contexts/BrandPageBrandViewContext";
import { use } from "react";
export var useBrandView = function() {
    var _useBrandPageBrandViewContext = useBrandPageBrandViewContext(), brandViewLegacy = _useBrandPageBrandViewContext.brandViewLegacy, brandViewPromise = _useBrandPageBrandViewContext.brandViewPromise;
    if (brandViewPromise) {
        return use(brandViewPromise);
    }
    return brandViewLegacy;
};
